export enum AudienceType {
  All = "ALL",
  User = "USER",
  Team = "TEAM",
  Campaign = "CAMPAIGN",
  Role = "ROLE",
}